(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["zoh-home-hero"] && !Shopify.designMode) return;
  try {
    
if (!window.zohHomeTracking) {
 window.zohHomeTracking = true;
 document.addEventListener('click', function(event) {
  const link = event.target.closest('a[data-zoh-promotion],a[data-zoh-banner]');
  if (!link || window.Shopify?.designMode) return;
  const privacy = window.Shopify?.customerPrivacy;
  if (!privacy || !privacy.analyticsProcessingAllowed()) return;
  const promotion = {promotion_id:link.dataset.zohPromotion || link.dataset.zohBanner,promotion_name:link.textContent.trim(),creative_slot:link.dataset.zohPosition || "homepage",link_url:link.href};
  if (typeof window.gtag === 'function') window.gtag('event','select_promotion',promotion);
  if (window.Shopify?.analytics?.publish) window.Shopify.analytics.publish('zoh_home_promotion_click',promotion);
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zoh-kombucha-visual"] && !Shopify.designMode) return;
  try {
    
(() => {
 const init = root => {
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const params = new URLSearchParams(window.location.search);
  root.querySelectorAll('[data-brew-link]').forEach(link => {
   const url = new URL(link.href, window.location.origin);
   if (params.has('preview_theme_id')) url.searchParams.set('preview_theme_id', params.get('preview_theme_id'));
   if (params.get('view') === 'kombucha-visual') url.searchParams.set('view', 'kombucha-visual');
   link.href = url.toString();
  });
  const dialog = root.querySelector('dialog');
  root.querySelectorAll('[data-photo-url]').forEach(button => button.addEventListener('click', () => {
   const photo = dialog.querySelector('img');
   photo.src = button.dataset.photoUrl;
   photo.alt = button.dataset.photoAlt || '';
   dialog.showModal();
  }));
  dialog.querySelector('[data-close-photo]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  const sticky = root.querySelector('[data-brew-sticky]');
  const form = root.querySelector('.zb-form');
  if ('IntersectionObserver' in window) {
   new IntersectionObserver(entries => {
    sticky.hidden = entries[0].isIntersecting;
   }, { threshold: 0 }).observe(form);
  }
 };
 document.querySelectorAll('[data-brew-page]').forEach(init);
 document.addEventListener('shopify:section:load', event => init(event.target.querySelector('[data-brew-page]')));
})();


  } catch(e) { console.error(e); }
})();
})();
